(function() {
  "use strict";

    var constant = {
      'baseUrl': '/umbraco/surface/signtasks',
      'sessionApiUrl': '/umbraco/surface/session',
      'iframeSignUrl': '/umbraco/surface/bankidsign/iframe',
      'iframeLoginUrl': '/umbraco/surface/bankid/login',
      'iframeLoginMobileUrl': '/umbraco/surface/bankid/loginMobile',
      'loginErrorUrl': '/login-error',
      'logoutUrl': '/logout',
      'noSignTasksUrl': '/no-signtasks',
      'chooseSignTaskUrl': '/choose-agreement',
        'chooseDocumentUrl': 'choose-document',
      'customerUrl': 'customer',
      'signCompletedUrl': '/signing-completed',
      'uploadDocumentationUrl': '/upload-documentation',
      'insuranceUrl': '/insurance-page',
      'whiteWashUrl': '/customer',
      'allowedFiles': 'application/pdf,image/png,image/jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'allowedFileEndings': 'pdf, png, jpg, jpeg og docx.'
    };

    angular.module("eSign", [])
        .config(['$compileProvider', function($compileProvider) {}])
        .constant('appConfig', constant);
}());
